<template>
  <div class="col-sm mg-t-10 mg-sm-t-0">
    <div class="bg7 rounded-20 pos-relative" role="button">
      <h5 class="t-15 l-15 pos-absolute tx-white">Контент</h5>
      <div class="d-flex ht-250 wd-100p align-items-center justify-content-center">
        <ul class="list-group wd-100p tx-white">
          <li class="list-group-item d-flex align-items-center pd-y-2 bd-0" style="background: transparent">
            <feather type="circle" style="height: 20px"></feather>
            <h6 class="mg-l-5 mg-t-4 tx-semibold tx-12 tx-white mg-b-0">Видео хичээл</h6>
            <div class="mg-l-auto rounded tx-semibold tx-11 pd-x-6 pd-y-1" style="background: rgba(0, 0, 0, 0.2)">
              {{ contentObj.videoContentCount }}
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center pd-y-2 bd-0" style="background: transparent">
            <feather type="circle" style="height: 20px"></feather>
            <h6 class="mg-l-5 mg-t-4 tx-semibold tx-12 tx-white mg-b-0">Дасгал ажил</h6>
            <div class="mg-l-auto rounded tx-semibold tx-11 pd-x-6 pd-y-1" style="background: rgba(0, 0, 0, 0.2)">
              {{ contentObj.dasgalAjilCount }}
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center pd-y-2 bd-0" style="background: transparent">
            <feather type="circle" style="height: 20px"></feather>
            <h6 class="mg-l-5 mg-t-4 tx-semibold tx-12 tx-white mg-b-0">
              Унших материал
            </h6>
            <div class="mg-l-auto rounded tx-semibold tx-11 pd-x-6 pd-y-1" style="background: rgba(0, 0, 0, 0.2)">
              {{ contentObj.readContentCount }}
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center pd-y-2 bd-0" style="background: transparent">
            <feather type="circle" style="height: 20px"></feather>
            <h6 class="mg-l-5 mg-t-4 tx-semibold tx-12 tx-white mg-b-0">Нийт курс</h6>
            <div class="mg-l-auto rounded tx-semibold tx-11 pd-x-6 pd-y-1" style="background: rgba(0, 0, 0, 0.2)">
              {{ contentObj.allCourseCount }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { request } from "@/api/all";


export default {

  data() {
    return {
      contentObj: {
        allCourseCount: 0,
        dasgalAjilCount: 0,
        readContentCount: 0,
        videoContentCount: 0,
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "v2/Learn/GetHomeContentCount " },
        params: {
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.contentObj= res.data;
        }
      });
    },
  },
};
</script>
